module.exports = __webpack_public_path__ + "static/media/reactLogoTransparent.2133b3fa.png";